import music from "../Data/Music.json";
import React, { useState} from 'react';
import MusicCards from "./MusicCards";
import { Modal, Button, Form } from 'react-bootstrap';
import AdPopUp from "./AdPopUp";
import { Link } from "react-router-dom";
import picture2 from '../Data/Flakes.jpeg';
import picture3 from '../Data/BrakePads.jpg';

function MyVerticallyCenteredModal(props) {
    
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Cob's Soul Music
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" onChange={(e) => props.changeHandler(e)} placeholder="Enter email" />
                    <Form.Text className="text-muted">
                    We'll never share your email with anyone else.
                    </Form.Text>
                </Form.Group>
                <p>
                    Please enter your email address if you want to subscribe and receive notifications for new songs! You'll be able to listen to them right away!
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.email && props.onHide}>Submit</Button>
            </Modal.Footer>
        </Modal>
    );
}

function AdPopUp2() {
    
    const [adShow, setAdShow] = useState(true)

    return(
        <>
            <Modal show={adShow} onHide={() => setAdShow(false)}>
                <Modal.Body>
                    <div className="card text-white bg-info mb-3" style={{max_width: "20rem"}} >
                        <div className="card-header">Cereal Flakes</div>
                        <div className="card-body">
                            <img className ="Bucksimage" src={picture2} style={{ height: "40%", width: "90%"}}/>
                            <h4 className="card-title">
                                
                            </h4>
                            <p className="card-text">"Abestos free"</p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

function AdPopUp3() {
    
    const [adShow, setAdShow] = useState(true)    

    return(
        <>
            <Modal show={adShow} onHide = {() => setAdShow(false)}>
                <Modal.Body>
                    <div className="card text-white bg-info mb-3" style={{max_width: "20rem"}} >
                        <div className="card-header">Jim's Brake Pads</div>
                        <div className="card-body">
                            <img className ="Bucksimage" src={picture3} style={{ height: "40%", width: "90%"}}/>
                            <h4 className="card-title">
                            
                                
                            </h4>
                            <p className="card-text">“They work every time, 50% of the time”</p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

function SoulMusic() {
    const [genre, setGenre] = useState("");
    const [email, setEmail] = useState("");
    const [artist, setArtist] = useState("");
    const [data, setData] = useState([]);
    const [modalShow, setModalShow] = useState(true);
    
    
    console.log(music)

    
    
    const changeHandler = (e) => {
        console.log('email value change', e.target.value);
        setEmail(e.target.value);
    }

    const getFavor = () => {
        console.log('music data', JSON.parse(localStorage.getItem('music')));
        setData(JSON.parse(localStorage.getItem('music')) || []);
    }

    return (
        <>
            <div style={{ display: "grid" }}>
                <h2 style={{ gridColumn: 2, gridRow: 1, textAlign: "center" }}>
                    Cob's Soul Music
                </h2>
                <p style={{ gridColumn: 2, gridRow: 2, textAlign: "center" }}>
                    Welcome to Cob's very own music website! We have 14 base songs for you to play, and more to come!
                </p>
                <Link to="/DarkSoulMusic">Dark Version</Link>


                {/* <button style={{ gridColumn: 3, gridRow: 1 }}>My Favorites</button> */}
                <div style={{ gridColumn: 3, gridRow: 1 }}>
                    <select onChange={() => getFavor()}>
                        <option value="">My Favorites</option>
                        <option value="">Show All</option>
                        {data && data.length && data.map((favor) => (
                            <>
                                <option value={favor}>{favor}</option>
                            </>
                        ))}
                    </select>
                </div>
            </div>
            <div>
                <label>Decade</label>
                <select>
                    <option>
                        Modern
                    </option>
                </select>
                <label>Genre</label>
                <select onChange={(e) => setGenre(e.target.value)}
                    value={genre}>
                    <option value="">Show All</option>
                    {Array.from(new Set(music.map((track) => track.genre))).map((genre) => <option value={genre}>{genre}</option>)
                    }
                </select>
                <label>Artist</label>
                <select onChange={(e) => setArtist(e.target.value)}
                    value={artist}>
                    <option value="">Show All</option>
                    {Array.from(new Set(music.map((track) => track.artist))).map((artist) => <option value={artist}>{artist}</option>)
                    }
                </select>
            </div>
            <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                changeHandler={(e) => changeHandler(e)}
                email={email}
            />
            <AdPopUp
                
            />
            <AdPopUp2
                
            />
            <AdPopUp3
                
            />
            {
                music.filter(track => (track.genre === genre || genre === "") && (track.artist === artist || artist === "")).map(track => <MusicCards track={track} setModalShow={setModalShow} />)
            }
            
        </>
    );
}

export default SoulMusic;